function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.28125 10.15625 L 23.21875 0 L 21.097656 0 L 13.339844 8.816406 L 7.148438 0 L 0 0 L 9.371094 13.335938 L 0 23.984375 L 2.117188 23.984375 L 10.308594 14.671875 L 16.851562 23.984375 L 24 23.984375 Z M 11.382812 13.453125 L 10.433594 12.125 L 2.878906 1.5625 L 6.132812 1.5625 L 12.230469 10.085938 L 13.175781 11.414062 L 21.101562 22.5 L 17.851562 22.5 Z M 11.382812 13.453125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a30a444727f3c72dca450d766e39f429.svg";
export { ForwardRef as ReactComponent };